// Utils
import { getBrowser } from './utils'

// Plugins
import WebfontLoader from './plugins/WebFontLoader'

// BaseClass
import projectBase from './projectBase'

// Modules
import Viewport from './modules/Viewport'
import MatchHeight from './modules/MatchHeight'
import Carousel from './modules/Carousel'
// ネイティブ position: stickyに変更
// import ElementSticky from './modules/ElementSticky'
import Social from './modules/Social'
import Modal from './modules/Modal'
import Youtube from './modules/Youtube'

export default class Project {
  constructor() {
    this.initialize()

    this.modules = {
      viewport: new Viewport(),
      matchHeight: new MatchHeight('.js-match-height'),
      carousel: new Carousel('.js-carousel'),
      // sticky: new ElementSticky('.js-sticky'),
      social: new Social('.js-social'),
      youtube: new Youtube('.js-youtube'),
      modal: new Modal('.js-modal'),
    }

    this.addModules()
  }

  initialize() {
    // Init webfont
    new WebfontLoader()

    // Define Browser UA
    const browser = getBrowser()
    document.documentElement.classList.add(browser)
  }

  // ProjectBase にインスタンス化済のモジュールを追加
  addModules() {
    Object.keys(this.modules).forEach((name) => {
      projectBase.addModule(name, this.modules[name])
    })
  }
}
